import React, { Component } from 'react';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
class Thankyou extends Component {
    render() {
        return (
            <div>
                    <section class="get-abtstarted-section text-center">

                    <img
                              src="/assets/images/course/cyber-security-Awareness.jpg"
                              alt="Logo"
                              width="900"
                              height="360"
                            />
                    <center><h1 class="textcenter" >
                    THANK YOU</h1></center>
                    </section>

                    <div aria-label="breadcrumb">
               
                        <ol class="breadcrumb" >
                        <li class="breadcrumb-item"> <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>

                            <li class="breadcrumb-item active">THANK YOU</li>
                        </ol>
                    </div>
                     <section class="padding-default">
                    <div>
                        <br /><br />
                        <center>
                            <h4 class="text-center">Greeting...!</h4> 
                            </center><br />
                        <p class="mobile-text-justify">
                        "Thanking you for expressing your interest in becoming an instructor on edu plus now.<br />
                        We are thrilled to invite you to join our outstanding team of instructors. Our representatives will get back to you shortly."  </p>
                        <br /><br />

                    </div> 
                  </section>


            </div>
        );
    }
}

export default Thankyou ;